
import _ from 'lodash'
import React from 'react'

import Exam from '../../../../lib/IssueMapping/Exam'
import {
  bindTargetMixin,
  CancelButton,
  SaveButton
} from '../../../shared/FormBuilder'
import { Svg } from '../../../shared/NarusMaterial'
import SectionHeader from '../Symptoms/RoS/sectionHeader'

import {
  AbdomenForm,
  BackForm,
  CardiovascularForm,
  ExtremitiesForm,
  EyesForm,
  GeneralForm,
  GenitourinaryForm,
  HeadForm,
  IntegumentaryForm,
  MentalHealthForm,
  NeckForm,
  NeurologicalForm,
  RespiratoryForm
} from './components'

const Categories = ({ categories }) =>
  categories.map((category, index) => (
    <div
      className='nh-category-item-container'
      key={`PhysicalExamCategory${index}`}
    >
      <div className='nh-category-item-style'>
        <div
          className='nh-icon-container'
          lang='en'
        >
          {category.component}
          <span className='nh-label-style'>
            {' '}
            {category.label}
            {' '}
          </span>
        </div>
      </div>
    </div>
  ))

class PEform extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.state = {
      value: props.initialValues
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.otherCheckBoxState = this.otherCheckBoxState.bind(this)
  }

  otherCheckBoxState () {
    const keys = Object.keys(this.state.value)
    keys.forEach(k => {
      const newValue = this.state.value
      const key = _.lowerCase(_.startCase(k)).split(' ')[0]

      if (
        k === `${key}OtherText` &&
        this.state.value[k] &&
        !this.state.value[`${key}Other`]
      ) {
        newValue[`${key}Other`] = true
        this.setState({
          value: newValue
        })
      }

      if (
        k === `${key}OtherText` &&
        !this.state.value[k] &&
        this.state.value[`${key}Other`]
      ) {
        newValue[`${key}Other`] = false
        this.setState({
          value: newValue
        })
      }
    })
  }

  componentDidUpdate () {
    this.otherCheckBoxState()
  }

  renderGeneral () {
    const header = {
      icon: (
        <button
          name='general'
          className='nh-section-header-icon'
        >
          <Svg src='rosGeneral' />
        </button>
      ),
      label: 'General',
      mapping: Exam.general,
      fields: this.state.value.general,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <GeneralForm name='general' />
      </div>
    )
  }

  renderHead () {
    const header = {
      icon: (
        <button
          name='head'
          className='nh-section-header-icon'
        >
          <Svg src='rosGeneral' />
        </button>
      ),
      label: 'Head',
      mapping: Exam.head,
      fields: this.state.value.head,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <HeadForm name='head' />
      </div>
    )
  }

  renderEyes () {
    const header = {
      icon: (
        <button
          name='eyes'
          className='nh-section-header-icon'
        >
          <Svg src='rosEnte' />
        </button>
      ),
      label: 'Eyes',
      mapping: Exam.eyes,
      fields: this.state.value.eyes,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <EyesForm name='eyes' />
      </div>
    )
  }

  renderRespiratory () {
    const header = {
      icon: (
        <button
          name='respiratory'
          className='nh-section-header-icon'
        >
          <Svg src='rosRespiratory' />
        </button>
      ),
      label: 'Respiratory',
      mapping: Exam.respiratory,
      fields: this.state.value.respiratory,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <RespiratoryForm name='respiratory' />
      </div>
    )
  }

  renderCardiovascular () {
    const header = {
      icon: (
        <button
          name='cardiovascular'
          className='nh-section-header-icon'
        >
          <Svg src='rosCardiovascular' />
        </button>
      ),
      label: 'Cardiovascular',
      mapping: Exam.cardiovascular,
      fields: this.state.value.cardiovascular,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <CardiovascularForm name='cardiovascular' />
      </div>
    )
  }

  renderNeck () {
    const header = {
      icon: (
        <button
          name='neck'
          className='nh-section-header-icon'
        >
          <Svg src='rosGeneral' />
        </button>
      ),
      label: 'Neck',
      mapping: Exam.neck,
      fields: this.state.value.neck,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <NeckForm name='neck' />
      </div>
    )
  }

  renderBack () {
    const header = {
      icon: (
        <button
          name='back'
          className='nh-section-header-icon'
        >
          <Svg src='rosGeneral' />
        </button>
      ),
      label: 'Back',
      mapping: Exam.back,
      fields: this.state.value.back,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <BackForm name='back' />
      </div>
    )
  }

  renderAbdomen () {
    const header = {
      icon: (
        <button
          name='abdomen'
          className='nh-section-header-icon'
        >
          <Svg src='rosGeneral' />
        </button>
      ),
      label: 'Abdomen',
      mapping: Exam.abdomen,
      fields: this.state.value.abdomen,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <AbdomenForm name='abdomen' />
      </div>
    )
  }

  renderGenitourinary () {
    const header = {
      icon: (
        <button
          name='genitourinary'
          className='nh-section-header-icon'
        >
          <Svg src='rosGeneral' />
        </button>
      ),
      label: 'Genitourinary',
      mapping: Exam.genitourinary,
      fields: this.state.value.genitourinary,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <GenitourinaryForm name='genitourinary' />
      </div>
    )
  }

  renderExtremeties () {
    const header = {
      icon: (
        <button
          name='extremities'
          className='nh-section-header-icon'
        >
          <Svg src='rosGeneral' />
        </button>
      ),
      label: 'Extremities',
      mapping: Exam.extremities,
      fields: this.state.value.extremities,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <ExtremitiesForm name='extremities' />
      </div>
    )
  }

  renderNeurological () {
    const header = {
      icon: (
        <button
          name='neurological'
          className='nh-section-header-icon'
        >
          <Svg src='rosNeurological' />
        </button>
      ),
      label: 'Neurological',
      mapping: Exam.neurological,
      fields: this.state.value.neurological,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <NeurologicalForm name='neurological' />
      </div>
    )
  }

  renderIntegumentary () {
    const header = {
      icon: (
        <button
          name='integumentary'
          className='nh-section-header-icon'
        >
          <Svg src='rosIntegumentary' />
        </button>
      ),
      label: 'Integumentary',
      mapping: Exam.integumentary,
      fields: this.state.value.integumentary,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <IntegumentaryForm name='integumentary' />
      </div>
    )
  }

  renderMentalHealth () {
    const header = {
      icon: (
        <button
          name='psychiatric'
          className='nh-section-header-icon'
        >
          <Svg src='rosMentalhealth' />
        </button>
      ),
      label: 'Psychiatric',
      mapping: Exam.mentalhealth,
      fields: this.state.value.mentalhealth,
      type: 'PE'
    }

    return (
      <div>
        <SectionHeader header={header} />
        <MentalHealthForm name='mentalhealth' />
      </div>
    )
  }

  getValues () {
    return { ...this.state.value }
  }

  handleSubmit () {
    const { onSubmit } = this.props
    onSubmit(this.getValues())
  }

  render () {
    const categories = [
      {
        component: (
          <a
            href='#general'
            className='nh-icon-style'
          >
            <Svg src='rosGeneral' />
          </a>
        ),
        label: 'General',
        mapping: Exam.general,
        fields: this.state.value.general,
        type: 'checkbox'
      },
      {
        component: (
          <a
            href='#head'
            className='nh-icon-style'
          >
            <Svg src='rosGeneral' />
          </a>
        ),
        label: 'Head',
        mapping: Exam.head,
        fields: this.state.value.head,
        type: 'radiobutton'
      },
      {
        component: (
          <a
            href='#eyes'
            className='nh-icon-style'
          >
            <Svg src='rosEnte' />
          </a>
        ),
        label: 'Eyes',
        mapping: Exam.eyes,
        fields: this.state.value.eyes,
        type: 'radiobutton'
      },
      {
        component: (
          <a
            href='#neck'
            className='nh-icon-style'
          >
            <Svg src='rosGeneral' />
          </a>
        ),
        label: 'Neck',
        mapping: Exam.neck,
        fields: this.state.value.neck,
        type: 'radiobutton'
      },
      {
        component: (
          <a
            href='#respiratory'
            className='nh-icon-style'
          >
            <Svg src='rosRespiratory' />
          </a>
        ),
        label: 'Respiratory',
        mapping: Exam.respiratory,
        fields: this.state.value.respiratory,
        type: 'radiobutton'
      },
      {
        component: (
          <a
            href='#cardiovascular'
            className='nh-icon-style'
          >
            <Svg src='rosCardiovascular' />
          </a>
        ),
        label: 'Cardiovascular',
        mapping: Exam.cardiovascular,
        fields: this.state.value.cardiovascular,
        type: 'radiobutton'
      },
      {
        component: (
          <a
            href='#abdomen'
            className='nh-icon-style'
          >
            <Svg src='rosGeneral' />
          </a>
        ),
        label: 'Abdomen',
        mapping: Exam.abdomen,
        fields: this.state.value.abdomen,
        type: 'radiobutton'
      },
      {
        component: (
          <a
            href='#back'
            className='nh-icon-style'
          >
            <Svg src='rosGeneral' />
          </a>
        ),
        label: 'Back',
        mapping: Exam.back,
        fields: this.state.value.back,
        type: 'radiobutton'
      },
      {
        component: (
          <a
            href='#genitourinary'
            className='nh-icon-style'
          >
            <Svg src='rosGeneral' />
          </a>
        ),
        label: 'Genitourinary',
        mapping: Exam.genitourinary,
        fields: this.state.value.genitourinary,
        type: 'radiobutton'
      },
      {
        component: (
          <a
            href='#extremities'
            className='nh-icon-style'
          >
            <Svg src='rosGeneral' />
          </a>
        ),
        label: 'Extremities',
        mapping: Exam.extremities,
        fields: this.state.value.extremities,
        type: 'radiobutton'
      },
      {
        component: (
          <a
            href='#neurological'
            className='nh-icon-style'
          >
            <Svg src='rosNeurological' />
          </a>
        ),
        label: 'Neurological',
        mapping: Exam.neurological,
        fields: this.state.value.neurological,
        type: 'radiobutton'
      },
      {
        component: (
          <a
            href='#integumentary'
            className='nh-icon-style'
          >
            <Svg src='rosIntegumentary' />
          </a>
        ),
        label: 'Integumentary',
        mapping: Exam.integumentary,
        fields: this.state.value.integumentary,
        type: 'radiobutton'
      },
      {
        component: (
          <a
            href='#psychiatric'
            className='nh-icon-style'
          >
            <Svg src='rosMentalhealth' />
          </a>
        ),
        label: 'Psychiatric',
        mapping: Exam.mentalhealth,
        fields: this.state.value.mentalhealth,
        type: 'radiobutton'
      }
    ]

    return (
      <form className='nh-form-style'>
        <div className='row nh-form-margin-bottom'>
          <Categories categories={categories} />
        </div>
        {this.renderGeneral()}
        {this.renderHead()}
        {this.renderEyes()}
        {this.renderNeck()}
        {this.renderRespiratory()}
        {this.renderCardiovascular()}
        {this.renderAbdomen()}
        {this.renderBack()}
        {this.renderGenitourinary()}
        {this.renderExtremeties()}
        {this.renderNeurological()}
        {this.renderIntegumentary()}
        {this.renderMentalHealth()}

        <div className='row end-xs nh-form-margin-top'>
          <CancelButton onClick={this.props.cancel} />
          <SaveButton onClick={this.handleSubmit} />
        </div>
      </form>
    )
  }
}

export default PEform
